import {
  LinkModel,
  ListPartial,
  MultipleSectionsViewModel,
  SectionModel,
  ViewComponent,
  ViewComponentModels
} from '@flocasts/experience-service-types'
import { ParamMap } from '@angular/router'
import { isLinkModel, isListPartial } from '../shared/functions/type-guards'

// Results Guard
/**
 * Given a path like /results/7640164-some-slug/:resultContainerId, return resultContainerId as a number
 * Return null if the path is undefined or if it can't be split apart appropriately.
 */
export const getResultContainerIdFromUrlPath = (path?: string): number | null => {
  const splitPath = path?.split('/')

  return splitPath && splitPath.length >= 3 ? +splitPath[3] : null
}

// Result Tabs (on event hubs)
/***
 * for the time being, but overall we want to move away from plucking the first item and relying on that.
 * Mikey's overall point is that we shouldn't rely on a top-level property (or the first item's type),
 * but instead be more dynamic in what a section's items can display. but i don't think our FE is to a
 * point where we can support that, with the way we built it
 */
export const getSectionItemType = (
  resultsSections: ReadonlyArray<SectionModel<ViewComponentModels>>
): string | null => {
  return resultsSections && resultsSections[0].type !== 'message' && resultsSections[0]?.items[0]?.type
    ? resultsSections[0]?.items[0]?.type
    : null
}

export function mapLinkTypeToUrl(
  sections: (ViewComponent | SectionModel<ViewComponentModels> | LinkModel)[]
): string | undefined {
  const link = sections.find(isLinkModel)
  return link && link.url ? link.url : undefined
}

// Result Index (List)
/**
 * Checks that results list filters are new.
 *
 * TODO: Add facet filters {@link https://flocasts.atlassian.net/browse/FLO-15349}
 */
export function matchingResultIndexQueryParams(x: ParamMap, y: ParamMap): boolean {
  return x.get('search') === y.get('search') && x.get('date') === y.get('date') && x.get('nav_id') === y.get('nav_id')
}

/**
 *
 * @param response - the response from the BFF results tab endpoint
 * @returns an array of ViewComponents or SectionsModels containing ViewComponents
 */
export function getResultsTabSections(
  response: ListPartial | MultipleSectionsViewModel
): (ViewComponent | SectionModel<ViewComponentModels>)[] {
  if (isListPartial(response)) {
    return response.data.sections
  } else {
    return response.sections
  }
}
